import styled, { css } from 'styled-components';
import { $ as $f7dceffc5ad7768b$export$4e328f61c538687f } from '../../3rdPartyModules/_react-aria/focus/dist/useFocusRing-BO5gj-B1.js';
import { $ as $3ef42575df84b30b$export$9d1611c77c2fe928 } from '../../3rdPartyModules/_react-aria/utils/dist/mergeProps-DMtmc2Zw.js';
import { f as focusPseudoElementsAfter } from '../../FocusIndicator/styleMixins/focusPseudoElementsAfter-DYbe7tJD.js';
import { i as isMobile } from '../../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { c as colorMixin } from '../Button-Cv4kr51v.js';

const selectButtonStyleTheme = key => ({
  theme,
  $primary
}) => {
  const buttonType = theme.button[$primary ? 'primary' : 'default'];
  return buttonType[key];
};
const baseStyles = /*#__PURE__*/css(["white-space:nowrap;color:", ";cursor:", ";text-align:center;vertical-align:middle;border-width:", ";border-style:solid;padding:0 ", ";user-select:auto;@media (prefers-reduced-motion:no-preference){transition:color 100ms ease,background-color 100ms ease,border-color 100ms ease,box-shadow 100ms ease;}"], selectButtonStyleTheme('color'), ({
  theme
}) => theme.button.cursor, ({
  theme
}) => theme.button.borderWidth, ({
  $small
}) => $small === true ? '8px' : '10px');
const determineStyles = /*#__PURE__*/css(["background:", ";border-color:", ";:hover{background:", ";}:active{border-color:", ";background:", ";}:disabled{cursor:not-allowed;outline:none;opacity:1;color:", ";background:", ";border-color:", ";pointer-events:all;}"], selectButtonStyleTheme('bg'), selectButtonStyleTheme('borderColor'), selectButtonStyleTheme('bgHover'), selectButtonStyleTheme('borderColorActive'), selectButtonStyleTheme('bgActive'), selectButtonStyleTheme('colorDisabled'), selectButtonStyleTheme('bgDisabled'), selectButtonStyleTheme('borderColorDisabled'));
const selectButtonSizeTheme = key => ({
  theme,
  $small
}) => {
  const buttonType = theme.button[$small ? 'small' : 'normal'];
  return buttonType[key];
};
const selectButtonSizeMobileTheme = key => ({
  theme,
  $small
}) => {
  const buttonType = theme.button[$small ? 'small' : 'normal'].mobile;
  return buttonType[key];
};
const determineSizeStyles = /*#__PURE__*/css(["padding-top:", ";padding-bottom:", ";padding-inline-start:", ";padding-inline-end:", ";font-size:", ";", ""], selectButtonSizeTheme('paddingV'), selectButtonSizeTheme('paddingV'), selectButtonSizeTheme('paddingH'), selectButtonSizeTheme('paddingH'), selectButtonSizeTheme('fontSize'), isMobile(css(["padding-top:", ";padding-bottom:", ";padding-inline-start:", ";padding-inline-end:", ";font-size:", ";"], selectButtonSizeMobileTheme('paddingV'), selectButtonSizeMobileTheme('paddingV'), selectButtonSizeMobileTheme('paddingH'), selectButtonSizeMobileTheme('paddingH'), selectButtonSizeMobileTheme('fontSize'))));
const defaultButtonStyling = /*#__PURE__*/css(["position:relative;", ";", " ", " ", ""], ({
  theme
}) => theme.typography.base, baseStyles, determineStyles, determineSizeStyles);
const selectRadius = ({
  theme
}) => theme.button.borderRadius;
const selectInnerRadius = ({
  theme
}) => theme.splitButton.innerBorderRadius;
const removeInlineStartBorder = /*#__PURE__*/css(["/*! @noflip */ border-radius:", " ", " ", " ", ";::after{/*! @noflip */ border-radius:", " ", " ", " ", ";}/*! @noflip */ [dir=\"rtl\"] &{/*! @noflip */ border-radius:", " ", " ", " ", ";::after{/*! @noflip */ border-radius:", " ", " ", " ", ";}}"], selectRadius, selectInnerRadius, selectInnerRadius, selectRadius, selectRadius, selectInnerRadius, selectInnerRadius, selectRadius, selectInnerRadius, selectRadius, selectRadius, selectInnerRadius, selectInnerRadius, selectRadius, selectRadius, selectInnerRadius);
const removeInlineEndBorder = /*#__PURE__*/css(["/*! @noflip */ border-radius:", " ", " ", " ", ";::after{/*! @noflip */ border-radius:", " ", " ", " ", ";}/*! @noflip */ [dir=\"rtl\"] &{/*! @noflip */ border-radius:", " ", " ", " ", ";::after{/*! @noflip */ border-radius:", " ", " ", " ", ";}}"], selectInnerRadius, selectRadius, selectRadius, selectInnerRadius, selectInnerRadius, selectRadius, selectRadius, selectInnerRadius, selectRadius, selectInnerRadius, selectInnerRadius, selectRadius, selectRadius, selectInnerRadius, selectInnerRadius, selectRadius);
const loadingStyles = /*#__PURE__*/css(["&&[aria-disabled=\"true\"]{cursor:not-allowed;outline:none;opacity:1;", " background:", ";border-color:", ";pointer-events:all;}"], colorMixin(selectButtonStyleTheme('colorDisabled')), selectButtonStyleTheme('bgDisabled'), selectButtonStyleTheme('borderColorDisabled'));
const StyledMainButton = /*#__PURE__*/styled('button').attrs(({
  onFocus,
  onBlur
}) => {
  const {
    isFocusVisible,
    focusProps
  } = $f7dceffc5ad7768b$export$4e328f61c538687f();
  return {
    /*
     *`useFocusRing()` uses `onFocus` and `onBlur` props, so `mergeProps()` must be used to
     * make sure user supplied `onFocus` and `onBlur` are also called. blah
    */
    ...$3ef42575df84b30b$export$9d1611c77c2fe928({
      onFocus,
      onBlur
    }, focusProps),
    focusVisible: isFocusVisible
  };
}).withConfig({
  componentId: "sc-storm-ui-30065889__sc-m59f18-0"
})(["margin:0;margin-inline-end:2px;", ";", ";", ";", ";:focus{outline:none;", "}"], defaultButtonStyling, removeInlineStartBorder, ({
  $loading
}) => $loading && loadingStyles, ({
  $fullWidth
}) => $fullWidth && css(["flex-grow:1;"]), ({
  focusVisible
}) => focusVisible && focusPseudoElementsAfter);
StyledMainButton.displayName = 'StyledMainButton';
const StyledDropdownButton = /*#__PURE__*/styled('button').attrs(({
  onFocus,
  onBlur
}) => {
  const {
    isFocusVisible,
    focusProps
  } = $f7dceffc5ad7768b$export$4e328f61c538687f();
  return {
    /*
     *`useFocusRing()` uses `onFocus` and `onBlur` props, so `mergeProps()` must be used to
     * make sure user supplied `onFocus` and `onBlur` are also called.
    */
    ...$3ef42575df84b30b$export$9d1611c77c2fe928({
      onFocus,
      onBlur
    }, focusProps),
    focusVisible: isFocusVisible
  };
}).withConfig({
  componentId: "sc-storm-ui-30065889__sc-m59f18-1"
})(["", " ", " color:", ";:hover{color:", ";}:disabled{color:", ";}:focus{outline:none;", "}margin:0;padding-inline-start:10px;padding-inline-end:11px;", " display:flex;flex-direction:row;flex-wrap:nowrap;justify-content:center;align-content:center;align-items:center;"], defaultButtonStyling, removeInlineEndBorder, ({
  $primary,
  theme
}) => theme.splitButton[$primary ? 'primary' : 'default'].dropdown.color, ({
  $primary,
  theme
}) => theme.splitButton[$primary ? 'primary' : 'default'].dropdown.hoverColor, ({
  $primary,
  theme
}) => theme.splitButton[$primary ? 'primary' : 'default'].dropdown.disabledColor, ({
  focusVisible
}) => focusVisible && focusPseudoElementsAfter, ({
  $small
}) => $small && css(["padding-inline-start:8px;padding-inline-end:9px;"]));
StyledDropdownButton.displayName = 'StyledDropdownButton';

/*
 * It is less complicated to collapse borders between elements with negative margin than
 * controlling borders within the child elements.
 */
const collapseInlineChildBorders = /*#__PURE__*/css(["> *:not(:first-child){margin-inline-end:0;margin-inline-start:0;}"]);
const ButtonGroupFrame = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-30065889__sc-m59f18-2"
})(["display:inline-flex;", ""], collapseInlineChildBorders);
const SplitButtonWrapper = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-30065889__sc-m59f18-3"
})(["display:flex;"]);
const HiddenLabelText = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-30065889__sc-m59f18-4"
})(["clip:rect(1px,1px,1px,1px);clip-path:inset(50%);height:1px;width:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;"]);

export { ButtonGroupFrame as B, HiddenLabelText as H, SplitButtonWrapper as S, StyledMainButton as a, StyledDropdownButton as b };
//# sourceMappingURL=SplitButton.styles-B2maGcyh.js.map
